var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiCounter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_counter",
    "data-name": "MDI / counter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#ff9800",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_counter",
    "data-name": "Path / counter",
    d: "M3.667,4H17a1.667,1.667,0,0,1,1.667,1.667v10A1.667,1.667,0,0,1,17,17.333H3.667A1.667,1.667,0,0,1,2,15.667v-10A1.667,1.667,0,0,1,3.667,4m0,1.667v10H9.5v-10H3.667M17,15.667v-10H15.967a2.091,2.091,0,0,1,.158.942,3.311,3.311,0,0,1-.592,1.35l-1.942,2.125,2.767-.017.008,1.017-4.333-.025L12,10.225s2.542-2.692,2.667-2.933.592-1.625-.583-1.625a.939.939,0,0,0-.908,1.083l-1.283.008a2.529,2.529,0,0,1,.317-1.092H11.167v10h2.15l-.008-.717.808-.008a.927.927,0,0,0,.767-.875.731.731,0,0,0-.8-.833c-.108,0-.892.042-.892.725H11.925s.033-1.717,2.158-1.717c2.167,0,2.05,1.683,2.05,1.683a1.553,1.553,0,0,1-.925,1.433l.433.308H17M7.767,14H6.517V9.167l-1.5.467V8.608l2.617-.933h.133Z",
    transform: "translate(-0.333 -0.667)",
    fill: "#ff9800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCounter);
export default __webpack_public_path__ + "static/media/MDI - counter.5fb4bd5537ff40fdc23ad5e9a6fc663e.svg";
export { ForwardRef as ReactComponent };